// ==============================
// ユーティリティ
// ==============================

// "09:30" → 9.5
function timeToDecimal(timeStr) {
  if (!timeStr) return 0;
  const [h, m] = timeStr.split(':').map(Number);
  return h + (m || 0) / 60;
}

// 9.5 → "9:30"
function formatTime(decimal) {
  const hour = Math.floor(decimal);
  const min = Math.round((decimal - hour) * 60);
  return `${hour}:${String(min).padStart(2, '0')}`;
}

// JST取得
function getJSTDate() {
  const now = new Date();
  return new Date(now.toLocaleString("en-US", { timeZone: "Asia/Tokyo" }));
}

// ==============================
// アコーディオン
// ==============================
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const isRunning = "running";
  const isOpend = "is-opened";

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-content");

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (element.dataset.animStatus === isRunning) return;

      if (element.open) {
        element.classList.toggle(isOpend);
        const closingAnim = content.animate([
          { height: content.offsetHeight + "px", opacity: 1 },
          { height: 0, opacity: 0 },
        ], { duration: 400, easing: "ease-out" });

        element.dataset.animStatus = isRunning;
        closingAnim.onfinish = () => {
          element.removeAttribute("open");
          element.dataset.animStatus = "";
        };
      } else {
        element.setAttribute("open", "true");
        element.classList.toggle(isOpend);

        const openingAnim = content.animate([
          { height: 0, opacity: 0 },
          { height: content.offsetHeight + "px", opacity: 1 },
        ], { duration: 400, easing: "ease-out" });

        element.dataset.animStatus = isRunning;
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
};

// ==============================
// トグル
// ==============================
function setUpToggle() {
  const buttons = document.querySelectorAll('.js-toggle');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.target);
      if (!target) return;

      if (target.style.height === '0px' || !target.style.height) {
        const inner = target.querySelector('.accordion-container');
        target.style.height = inner.offsetHeight + 'px';
        button.classList.add('is-opened');
      } else {
        target.style.height = '0px';
        button.classList.remove('is-opened');
      }
    });
  });
}

// ==============================
// フローティングバナー
// ==============================
function setUpFloating() {
  const container = document.querySelector(".js-inner");
  const target = document.querySelector(".float-banner");
  if (!container || !target) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      target.classList.toggle("is-shown", entry.isIntersecting);
    });
  });

  observer.observe(container);
}

// ==============================
// 診療時間システム
// ==============================

function initClinicSchedule() {
  const el = document.getElementById('clinic-data');
  if (!el) return null;

  try {
    const rawWeekly = JSON.parse(el.dataset.weekly);
    const rawSpecial = JSON.parse(el.dataset.special);

    const weekly = {};
    const special = {};

    Object.keys(rawWeekly).forEach(day => {
      const slots = rawWeekly[day];
      if (!slots) return weekly[day] = null;

      weekly[day] = slots.map(s => ({
        start: timeToDecimal(s.start),
        end: timeToDecimal(s.end)
      }));
    });

    Object.keys(rawSpecial).forEach(date => {
      const slots = rawSpecial[date];
      if (!slots) return special[date] = null;

      special[date] = slots.map(s => ({
        start: timeToDecimal(s.start),
        end: timeToDecimal(s.end)
      }));
    });

    return { weekly, special };

  } catch (e) {
    console.error('JSONエラー', e);
    return null;
  }
}

function getTodaySchedule(date, schedules) {
  const { weekly, special } = schedules;

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const key = `${y}-${m}-${d}`;

  if (key in special) return special[key];
  return weekly[date.getDay()] || null;
}

function isOpen(now, schedule) {
  if (!schedule) return false;
  const current = now.getHours() + now.getMinutes() / 60;
  return schedule.some(s => current >= s.start && current < s.end);
}

function getNextStart(now, schedule) {
  if (!schedule) return null;
  const current = now.getHours() + now.getMinutes() / 60;

  for (let s of schedule) {
    if (current < s.start) return s.start;
  }
  return null;
}

function getNextOpen(now, schedules) {
  let d = new Date(now);

  for (let i = 0; i < 10; i++) {
    d.setDate(d.getDate() + 1);
    const s = getTodaySchedule(d, schedules);
    if (s) return { date: new Date(d), schedule: s };
  }

  return null;
}

function updateClinicStatus() {
  const schedules = initClinicSchedule();
  if (!schedules) return;

  const inner = document.getElementById('marquee-inner');
  if (!inner) return;

  const now = getJSTDate();
  const today = getTodaySchedule(now, schedules);

  let msg = `（截至 ${now.toLocaleString('zh-CN')}）`;

  if (isOpen(now, today)) {
    msg += '当前为接诊时间。';
  } else {
    msg += '当前为非接诊时间。';

    const next = getNextStart(now, today);

    if (next !== null) {
      msg += `下一次接诊时间为 ${formatTime(next)}。`;
    } else {
      const n = getNextOpen(now, schedules);
      if (n) {
        msg += `下一次接诊日期为 ${n.date.getMonth()+1}月${n.date.getDate()}日 ${formatTime(n.schedule[0].start)}。`;
      } else {
        msg += '下一次接诊时间尚未确定。';
      }
    }
  }

  inner.innerHTML = `<span class="marquee-item">${msg}</span><span class="marquee-item">${msg}</span>`;

  requestAnimationFrame(() => {
    const item = inner.querySelector('.marquee-item');
    if (!item) return;

    const gap = 300;
    const width = item.offsetWidth + gap;

    inner.style.animation = `marqueeMove ${width / 70}s linear infinite`;

    const oldStyle = document.getElementById('marquee-style');
    if (oldStyle) oldStyle.remove();

    const style = document.createElement('style');
    style.id = 'marquee-style';
    style.innerHTML = `
      @keyframes marqueeMove {
        from { transform: translateX(0); }
        to { transform: translateX(-${width}px); }
      }
    `;
    document.head.appendChild(style);
  });
}

// ==============================
// 初期化
// ==============================
window.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
  setUpToggle();
  setUpFloating();
  updateClinicStatus();
});

